<script>
import SquareButton from "../../../common/squareButton.vue";
import IconTooltip from "../../../../common/icon-tooltip.vue";
import CalendarThumbnail from "./calendar-thumbnail.vue";
import {getEventTitle} from "../calendarUtils";
import PublishApproveSwitch from "../../publish-approve-switch.vue";
import CalendarEventMenuIcon from "./calendar-event-menu-icon.vue";
import VTooltipWrapper from "../../../../common/v-tooltip-wrapper.vue";
import CalendarEvent from "./CalendarEvent";
import CalendarEventTitle from "./calendar-event-title.vue";
import CalendarElementType from "./calendar-element-type.vue";

export default {
    name: "calendar-event-menu",
    components: {
        CalendarElementType,
        CalendarEventTitle,
        VTooltipWrapper, CalendarEventMenuIcon, PublishApproveSwitch, CalendarThumbnail, IconTooltip, SquareButton},
    props: {
        event: {
            type: CalendarEvent,
            required: true
        },
        width: Number,
    },
    computed: {
        /** @type CalendarPublishElement */
        element() {
            return this.event.elementData;
        },
        /** @type CalendarActionItem[] */
        actions() {
            return this.event.actions;
        },
        translations() {
            return {
                close: Lang.langGet('Close')
            }
        },
        title() {
            return getEventTitle(this.element);
        },
        approvePrivilege() {
            if (this.event.privileges.canApprove()) return '1';
            return null;
        },
        switchLabel() {
            if (this.element.data.approved) return Lang.langGet('Approved');
            return Lang.langGet('Not approved');
        }
    },
    methods: {
        /** @param item {CalendarActionItem} */
        handleItemClick(item) {
            this.$emit('click', item);
            if (item.id === 'preview') this.$emit('close');
        },
    }
}
</script>

<template>
    <v-card :width="width + 20">
        <div class="calendar-event-menu-container">
            <div class="header-row">
                <calendar-event-title :event="event" show-only-title class="title-wrapper" />

                <div class="action-icons">
                    <calendar-event-menu-icon v-for="action in actions"
                        class="action-item" size="small"
                        :key="action.label"
                        :icon="action.icon"
                        :tooltip="action.label"
                        @click="handleItemClick(action)"
                    />

                    <calendar-event-menu-icon :tooltip="translations.close" icon="far fa-close" @click="$emit('close')" class="action-item" size="small" />
                </div>
            </div>

            <calendar-thumbnail :element="element" :width="width" />

            <div class="controls-row">
                <calendar-element-type
                    class="left-content"
                    :element="element"
                />

<!--                {{event.timestamp}}-->

                <div class="switch-container">
                    <span class="switch-label">{{switchLabel}}</span>
                    <publish-approve-switch
                        :inset="false"
                        :value="element.data.approved"
                        :marked-for-deletion="!!element.deletedAt"
                        :approve-privilege="approvePrivilege"
                        @input="value => $emit('change', {property: 'approved', value})"
                    />
                </div>
            </div>
        </div>
    </v-card>
</template>

<style>
    .calendar-event-menu-container {
        padding: 4px 8px 4px 8px;

        .header-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }

        .title-wrapper {
            flex-grow: 1;
            margin-right: 10px;
        }

        .action-icons {
            display: flex;
            justify-content: flex-end;
            flex-shrink: 0;
        }

        .action-item {
            color: color-mix(in srgb, var(--color-eicon-original) 68%, transparent);
        }

        .controls-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-top: 8px;
            padding: 6px;
            overflow: hidden;
        }

        .left-content {
            display: flex;
            min-width: 24px;
            flex-shrink: 0;
            .element-icon-outer-container {
                margin-right: 4px
            }
        }

        .switch-container {
            display: flex;
            align-items: center;
            min-width: 42px;
            flex-shrink: 0;
            .v-input--selection-controls__input {
                margin-right: 0 !important;
                width: 38px !important;
            }
        }

        .switch-label {
            margin-right: 8px;
        }
    }
</style>
